import React from 'react';
import { MODE_OF_TRANSPORT } from '../../../../models/Onboarding/onboarding-values';
import { ICandidateDetails } from '../../../../store/superadmin/types';
import { TSubUrbs } from '../../../../store/onboarding/types';

interface JobPreferenceProps {
    showJobPreference: boolean;
    reviewCandidateData: ICandidateDetails | null;

}
const JobPreference: React.FC<JobPreferenceProps> = ({showJobPreference, reviewCandidateData}) => {
    const jobpreference = reviewCandidateData?.jobpreference ?? null;
    const modeOfTransport = jobpreference !== null && jobpreference?.[0]?.preferred_transport_modes 
        ? JSON.parse(jobpreference[0].preferred_transport_modes) 
        : [];

    const jobPreferenceSubrubs = jobpreference !== null && jobpreference?.[0]?.jobpreferencesubrubs 
        ? jobpreference?.[0]?.jobpreferencesubrubs 
        : [];

    const modeOfTransports = [
        {id: "a", label: MODE_OF_TRANSPORT.CAR},
        {id: "b", label: MODE_OF_TRANSPORT.BUS},
        {id: "c", label: MODE_OF_TRANSPORT.TRAIN},
        {id: "d", label: MODE_OF_TRANSPORT.TRAM}        
    ];

    return (
       <>
        <div className={`d-flex flex-column gap-20 fw-400 text-black ${showJobPreference ? "" : "d-none"}`}>
            <div className="fs-22">Job Preferences</div>
            <div className="d-flex flex-column gap-5">
                <div className="fs-13 text-grey-medium">
                    Maximum travel distance from home
                </div>
                <div className="fs-16">
                    {jobpreference ? `${jobpreference?.[0]?.max_travel_distance ? jobpreference?.[0]?.max_travel_distance + "km" : "No data"  }` : "No data"}
                </div>
            </div>
            <div className="d-flex flex-column gap-5">
                <div className="fs-13 text-grey-medium">
                    Preferred mode/s of transport
                </div>
                <div className="d-flex gap-5">
                    {
                        modeOfTransport?.length > 0 ? modeOfTransport.map((item: string, index: number) => {
                        return (
                            <div className={`checkbox-icon`} key={index}>
                                <input type="checkbox" className='checkbox-icon-input' checked/>
                                <label className='checkbox-icon-label'>{modeOfTransports?.find(transport => transport.label === item)?.label ?? ""}<span className={`icon-${modeOfTransports?.find(transport => transport.label === item)?.label.toLowerCase() ?? ""}`}></span></label>
                            </div>
                        )
                    }) : "No data"}
                    
                    
                </div>
            </div>
            <div className="d-flex flex-column gap-5">
                <div className="fs-13 text-grey-medium">
                    Preferred job locations:
                </div>
                <div className="fs-16">
                {
                    jobPreferenceSubrubs?.length > 0
                        ? jobPreferenceSubrubs
                            .map((suburb: TSubUrbs) =>
                                typeof suburb === "string"
                                    ? suburb
                                    : suburb?.suburb
                                        ? suburb.suburb
                                        : ""
                            )
                            .filter(Boolean)
                            .join(", ")
                        : "No data"
                }
                </div>
            </div>
        </div>
       </>
    );
};

export default JobPreference;